var React = require('react');

function AccordionArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 11.1716L7 2C7 0.895431 7.89543 0 9 0C10.1046 0 11 0.895431 11 2L11 11.1716L14.5858 7.58579C15.3668 6.80474 16.6332 6.80474 17.4142 7.58579C18.1953 8.36683 18.1953 9.63317 17.4142 10.4142L10.4142 17.4142C9.63317 18.1953 8.36683 18.1953 7.58579 17.4142L0.585786 10.4142C-0.195262 9.63317 -0.195262 8.36683 0.585786 7.58579C1.36683 6.80474 2.63316 6.80474 3.41421 7.58579L7 11.1716Z"}));
}

AccordionArrow.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = AccordionArrow;

AccordionArrow.default = AccordionArrow;
